import React, { useEffect, useState } from "react";
import API from "../../services/api";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import "react-json-view-lite/dist/index.css";
import { Toast } from "../../shared/Toast";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router";
import { languageOptions, stateOptions, fetchMatchAdCodeAlert, slotOptions, getOverlapStatus } from "../../utils/constants";
import { formatDateWithTime } from "../../utils/dateFormat";
import TargetPreview from "./TargetPreview";
import DeleteSvg from "../../assets/images/delete_icon.svg";
import CloseCrosssvg from "../../assets/images/close_cross_icon.svg";
import Select from 'react-select'
import LineitemPreview from "../campaign/LineitemPreview";

function InternalAds(props) {
  const navigate = useNavigate();
  const [internalAds, setInternalAds] = useState([]);
  const [loader, setLoader] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [removeData, setRemoveData] = useState({});
  const [showRemoveAlert, setShowRemoveAlert] = useState(false);
  const [newPosition, setNewPosition] = useState("");
  const [newSlot, setNewSlot] = useState(props.slot ?? 0);
  const [add, setAdd] = useState(false);
  const [lineItemData, setLineItemData] = useState([]);
  const [submitClicked, setSubmitClicked] = useState(false);
  const [removeClicked, setRemoveClicked] = useState(false);
  const [target_filter, setTarget_filter] = useState({
    lang_id: "1",
    state_id: "-1",
    district_id: "-1",
    constituency_id: "-1",
    zone_id: "-1",
  });
  const [districtfilter, setDistrictfilter] = useState([]);
  const [constituencyfilter, setConstituencyfilter] = useState([]);
  const [zoneOptions, setZoneOptions] = useState([]);
  const [adIds, setAdIds] = useState([]);
  const [hiddens, setHiddens] = useState([]);
  const [hidden, setHidden] = useState();
  const [formData, setFormData] = useState();
  const [formSubmit, setFormSubmit] = useState(false);
  const [previewCampaignId, setPreviewCampaignId] = useState(null)
  const [matchAdCodeAlert, setMatchAdCodeAlert] = useState({});
  const [selectedPositions, setSelectedPositions] = useState([props.position]);
  const [submitProgress, setSubmitProgress] = useState({ completed: 0, total: 0, currentPos: null });

  const form1 = useForm({ mode: "onSubmit" });
  const language = form1.getValues("lang_id");
  if (!language) form1.setValue("lang_id", "1");
  const watchLang = form1.watch("lang_id", "1");
  let watchState = form1.watch("state_id");
  let watchDist = form1.watch("district_id");
  let watchConstituency = form1.watch("constituency_id");
  let watchZone = form1.watch("zone_id");
  const fetchInternalAds = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "adunit/getInternalCamps",
        method: "POST",
        responseType: "json",
        data: {
          internalCampIds: adIds,
        },
      });
      if (res.code === 200) {
        let data = [];
        let ind = 0;
        res.data.map((item) => {
          item["hidden"] = hiddens[ind];
          ind++;
          data.push(item);
        });
        setInternalAds(data);
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleClose = () => {
    props.setShow(false);
    props.setPosition(false);
  };

  const setDataFields = () => {
    let ids = [];
    let hiddens = [];
    (props.internalAds || []).map((item) => {
      ids.push(item.campaign_id);
      hiddens.push(item.hidden);
    });
    setAdIds(ids);
    setHiddens(hiddens);
  };

  const removeFromPosition = async (data) => {
    let obj = { ...data };
    obj.campaign_name = undefined;
    obj.status = undefined;
    obj.rotation = undefined;

    try {
      let res = await API({
        url: "/adunit/publishUnit",
        method: "POST",
        responseType: "json",
        data: {
          ...obj,
          action: 0,
          hidden,
          lang_id: props.target.lang_id,
          slot: props.slot,
        },
      });
      if (res.code === 200) {
        Toast("success", "Removed Successfully!");
        let newArray = props.internalAds.filter(
          (item) =>
            parseInt(item.campaign_id) !== parseInt(data.campaign_id) &&
            item.hidden === hidden
        );
        props.setInternalAds(newArray);
        setShowRemoveAlert(false);
        setRemoveData({});
        setNewPosition("");
        setNewSlot(props.slot ?? 0);
        props.fetchAds(0, props.target);
      } else {
        Toast("error", res?.data?.message);
      }
      setRemoveClicked(false);
    } catch (error) {
      console.error(error);
    }
  };

  // For scheduled internal campaigns: publish the campaign at the newly entered
  // position first, then remove it from the current position (a "move").
  const publishNewPositionAndRemove = async (data) => {
    const targetPosition = parseInt(newPosition);
    if (newPosition === "" || isNaN(targetPosition)) {
      Toast("error", "Please enter a new position");
      setRemoveClicked(false);
      return;
    }
    const targetSlot = parseInt(newSlot);
    if (newSlot === "" || isNaN(targetSlot)) {
      Toast("error", "Please select a new slot");
      setRemoveClicked(false);
      return;
    }
    try {
      const publishRes = await API({
        url: "/adunit/publishUnit",
        method: "POST",
        responseType: "json",
        data: {
          campaign_id: data.campaign_id,
          backfill: data.backfill,
          ad_type: "panel",
          action: 1,
          position: targetPosition,
          rotation: data.rotation ? 1 : 0,
          lang_id: props.target.lang_id,
          hidden,
          slot: targetSlot,
        },
      });
      if (publishRes.code !== 200) {
        Toast("error", publishRes?.data?.message || "Failed to publish at new position");
        setRemoveClicked(false);
        return;
      }
      Toast("success", `Published at position #${targetPosition} ${slotOptions[targetSlot]}`);
      // Only remove from the current position once the new position is published.
      await removeFromPosition(data);
    } catch (error) {
      console.error(error);
      setRemoveClicked(false);
    }
  };

  function getHiddenvalue(targetValue) {
    const foundObject = lineItemData.find(
      (obj) => parseInt(obj.value) === parseInt(targetValue)
    );

    if (foundObject) {
      return foundObject.hidden;
    } else {
      return null; // Or handle the case when the value is not found
    }
  }

  const onSubmit = async (data) => {
    const positions = selectedPositions.length > 0 ? selectedPositions : [props.position];
    const total = positions.length;
    setSubmitProgress({ completed: 0, total, currentPos: positions[0] });

    let successCount = 0;
    for (let i = 0; i < positions.length; i++) {
      const pos = positions[i];
      setSubmitProgress({ completed: i, total, currentPos: pos });
      try {
        const res = await API({
          url: "/adunit/publishUnit",
          method: "POST",
          responseType: "json",
          data: { ...data, position: pos, slot: props.slot },
        });
        if (res.code === 200) {
          successCount++;
        } else {
          Toast("error", `Position #${pos}: ${res.data?.message || "Failed"}`);
        }
      } catch (error) {
        console.error(error);
        Toast("error", `Position #${pos} failed`);
      }
    }

    setSubmitProgress({ completed: total, total, currentPos: null });
    if (successCount > 0) {
      Toast("success", total > 1 ? `Added to ${successCount}/${total} positions!` : "LineItem added Successfully!");
    }
    props.fetchAds(0, props.target);
    props.setInternalAds((prevAds) => [
      ...prevAds,
      { campaign_id: data.campaign_id, hidden: getHiddenvalue(data.campaign_id) },
    ]);
    // Delay close when multi-position so the user sees the "Done" state in the progress bar
    if (total > 1) await new Promise(res => setTimeout(res, 1000));
    setAdd(false);
    setSubmitClicked(false);
    setFormData(false);
    setFormSubmit(false);
    setSubmitProgress({ completed: 0, total: 0, currentPos: null });
    setSelectedPositions([props.position]);
    form1.reset();
  };

  const dummySubmit = async (data) => {
    setPreviewCampaignId(data.adName?.value)
    setMatchAdCodeAlert(await fetchMatchAdCodeAlert({campaign_id: data.adName?.value, lang_id: watchLang, slot: props.slot, position: props.position}))
    setSubmitClicked(true);
    const isBackfill = props.backfill || props.from === "Backfill";
    let formData = {
      campaign_id: data.adName?.value,
      backfill: isBackfill,
      ad_type: "panel",
      action: 1,
      position: props.position,
      rotation: data.rotation ? 1 : 0,
      lang_id: watchLang,
      hidden: getHiddenvalue(data.adName?.value),
    };
    setFormData(formData);
  };
  const fetchAds = async () => {
    setSpinner(true);
    try {
    let res = await API({
      url: "/adunit/PositionalAds",
      method: "POST",
      responseType: "json",
      data: {
        target_filter: {
          lang_id: watchLang,
          state_id: watchState || "-1",
          district_id: watchDist || "-1",
          constituency_id: watchConstituency || "-1",
          zone_id: watchZone || "-1",
        },
        position: props.position,
        backfill: props.backfill || props.from === "Backfill",
        slot: props.slot,
      },
    });
      if (res.code === 200) {
        setLineItemData(res.data?.final_campaigns);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSpinner(false);
    }
  };
  const LanguageFilterChange = () => {
    setTarget_filter((prevState) => ({ ...prevState, lang_id: watchLang }));
    form1.setValue("zone_id", "");
    fetchZonesByLang(watchLang);
    if (props.from === 1) {
      fetchAds();
    }
    if (props.from >= 2) form1.setValue("state_id", "");
    if (props.from >= 3) {
      form1.setValue("district_id", "");
      setDistrictfilter([]);
    }
    if (props.from >= 4) {
      form1.setValue("constituency_id", "");
      setConstituencyfilter([]);
    }
    form1.setValue("adName", "");
  };

  const fetchZonesByLang = async (watchLang = 1) => {
    try {
      let zoneOptions = await API({
        url: "/location/getZones",
        method: "POST",
        responseType: "json",
        data: { lang_id: watchLang },
      });
      if (zoneOptions?.code === 200) {
        let zoneOptionsArr = [];
        for await (let item of zoneOptions.data) {
          const temp = { value: item.zone_id, label: `${item.zone_name}` };
          zoneOptionsArr.push(temp);
        }
        setZoneOptions(zoneOptionsArr);
      } else {
        setZoneOptions([]);
      }
    } catch (error) {
      console.error(error);
      setZoneOptions([]);
    }
  };

  const ZoneFilterChange = async () => {
    setTarget_filter((prevState) => ({ ...prevState, zone_id: +watchZone }));
    if (props.from === 5) {
      fetchAds();
    }
  };

  const StateFilterChange = async () => {
    if (watchState !== "-1" && watchState) {
      try {
        let res = await API({
          url: "/location/getDistrictsByStateId",
          method: "POST",
          responseType: "json",
          data: { states: [watchState], langs: [watchLang] },
        });
        if (res.code === 200) {
          let districts = [];
          for await (let item of res.data) {
            const temp = { value: item.dist_id, label: `${item.dist_name}` };
            districts.push(temp);
          }
          setDistrictfilter(districts);
          if (props.from >= 3) form1.setValue("district_id", "");
          if (props.from >= 4) {
            form1.setValue("constituency_id", "");
            setConstituencyfilter([]);
          }
          form1.setValue("adName", "");
          setTarget_filter((prevState) => ({
            ...prevState,
            state_id: watchState,
          }));
          if (props.from === 2) {
            fetchAds();
          }
        }
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
  };

  const DistrictFilterChanger = async () => {
    if (watchDist !== "-1" && watchDist) {
      try {
        let res = await API({
          url: "/location/getConstituentsnew",
          method: "POST",
          responseType: "json",
          data: { districts: [watchDist], langs: [watchLang] },
        });
        if (res.code === 200) {
          let mandals = [];
          for await (let item of res.data) {
            const temp = {
              value: item.const_id,
              label: `${item.const_name}`,
            };
            mandals.push(temp);
          }
          setConstituencyfilter(mandals);
          if (props.from >= 4) form1.setValue("constituency_id", "");
          form1.setValue("adName", "");
          setTarget_filter((prevState) => ({
            ...prevState,
            district_id: watchDist,
          }));
          if (props.from === 3) {
            fetchAds();
          }
        }
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
  };

  const constituencyFilterChange = async () => {
    setTarget_filter((prevState) => ({ ...prevState, constituency_id: watchConstituency }));
    fetchAds();
  };

  useEffect(() => {
    if (props.internalAds?.length > 0) {
      setDataFields();
    } else {
      setInternalAds([]);
    }
  }, [props.internalAds]);

  useEffect(() => {
    if (adIds.length > 0) fetchInternalAds();
  }, [adIds]);

  useEffect(() => {
    LanguageFilterChange();
  }, [watchLang]);
  useEffect(() => {
    if (
      props.from >= 2 &&
      target_filter.lang_id !== "-1" &&
      target_filter.state_id !== ""
    ) {
      StateFilterChange();
    }
  }, [watchState]);
  useEffect(() => {
    if (props.from >= 3 && target_filter.state_id !== "-1")
      DistrictFilterChanger();
  }, [watchDist]);
  useEffect(() => {
    if (props.from >= 4 && target_filter.district_id !== "-1")
      constituencyFilterChange();
  }, [watchConstituency]);
  useEffect(() => {
    if (props.from === 5)
      fetchZonesByLang(+watchLang);
  }, []);
  useEffect(() => {
    if (props.from === 5 && watchZone !== "-1")
      ZoneFilterChange();
  }, [watchZone]);

  return (
    <Modal show={props.show} onHide={handleClose}  centered className="popup-modal">
    <div className={"popup-container"}>
      <div className="popup-header">
        <h3>{props.from === 1 ? "Language" :props.from === 2 ? "State" :props.from === 3 ? "District" : props.from !== 'Backfill' ? props.from === 5 ? "Zone" : "Mandal" :"Backfill" } Ads</h3>
        <span className="close">
          <img src={CloseCrosssvg} onClick={handleClose} alt="Close" />
        </span>
      </div>
      <div className="popup-body">
        <div className="title-row">
          <h4>
            Ad Position: <b>#{props.position}</b>
          </h4>
          {props.from !== "Backfill" ? (
            <button onClick={() => setAdd(true)} className="add-line-item">
              + Add Line Item
            </button>
          ) : null}
        </div>

        {props.backfill && props.allBackfillPositions?.length > 0 && (
          <div className="mb-3 p-2 border rounded bg-light">
            <div className="d-flex align-items-center justify-content-between mb-2">
              <span className="small fw-semibold text-muted">Add to positions:</span>
              <div className="d-flex gap-2">
                <button type="button" className="btn btn-outline-secondary btn-sm py-0 px-2" style={{fontSize:'0.7rem'}}
                  onClick={() => setSelectedPositions(props.allBackfillPositions)}>All</button>
                <button type="button" className="btn btn-outline-secondary btn-sm py-0 px-2" style={{fontSize:'0.7rem'}}
                  onClick={() => setSelectedPositions([props.position])}>Reset</button>
              </div>
            </div>
            <div className="d-flex flex-wrap gap-2">
              {props.allBackfillPositions.map(pos => (
                <label key={pos} className="d-flex gap-1 align-items-center small mb-0 cursor-pointer"
                  style={{ userSelect: 'none' }}>
                  <input
                    type="checkbox"
                    checked={selectedPositions.includes(pos)}
                    onChange={() =>
                      setSelectedPositions(prev =>
                        prev.includes(pos) ? prev.filter(p => p !== pos) : [...prev, pos]
                      )
                    }
                  />
                  <span className={pos === props.position ? 'fw-bold' : ''}>#{pos}</span>
                </label>
              ))}
            </div>
          </div>
        )}

        {add ? (
          <div >
            <form className="form-container" onSubmit={form1.handleSubmit(dummySubmit)}>
              <div className="field-set">
                <label>Language</label>
                <select
                  name=""
                  id=""
                  {...form1.register("lang_id", { required: true })}
                >
                  {languageOptions.map((language) => {
                    return (
                      <option value={language.value} key={language.value}>
                        {language.label}
                      </option>
                    );
                  })}
                </select>
              </div>
              {props.from !== 5 ? <>
              {props.from >= 2 ? (
                <div className="field-set">
                  <label>State</label>
                  <select
                    name=""
                    id=""
                    {...form1.register("state_id", { required: true })}
                  >
                     <option value="">Select State</option>
                    {stateOptions
                      .filter((item) => item.lang_id === +watchLang)
                      .map((item) => {
                        return (
                          <option key={item.state_id} value={item.state_id}>
                            {item.state_name}
                          </option>
                        );
                      })}
                  </select>
                  {form1.formState.errors.state_id && (
                    <p className="text-red-600 my-0">State is Required</p>
                  )}
                </div>
              ) : null}
              {props.from >= 3 ? (
                <div className="field-set">
                  <label>District</label>
                  <select
                    name=""
                    id=""
                    {...form1.register("district_id", {
                      required: true,
                    })}
                  >
                                <option value="">Select District</option>
                    {districtfilter.map((district) => {
                      return (
                        <option value={district.value} key={district.value}>
                          {district.label}
                        </option>
                      );
                    })}
                  </select>
                  {form1.formState.errors.district_id && (
                    <p className="text-red-600 my-0">District is Required</p>
                  )}
                </div>
              ) : null}
              {props.from >= 4 ? (
                <div className="field-set">
                  <label>Constituency</label>
                  <select
                    name=""
                    id=""
                    {...form1.register("constituency_id", { required: true })}
                  >
                                <option value="">Select Constituency</option>

                    {constituencyfilter.map((mandal) => {
                      return (
                        <option value={mandal.value} key={mandal.value}>
                          {mandal.label}
                        </option>
                      );
                    })}
                  </select>
                  {form1.formState.errors.mandal_id && (
                    <p className="text-red-600 my-0">Constituency is Required</p>
                  )}
                </div>
              ) : null}
              </> : null}
              {props.from === 5 ? (
                <div className="field-set">
                  <label>Zone</label>
                  <select
                    name=""
                    id=""
                    {...form1.register("zone_id", { required: true })}
                  >
                    <option value="">Select Zone</option>
                    {zoneOptions.map((zone) => {
                      return (
                        <option value={zone.value} key={zone.value}>
                          {zone.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
              ) : null}
              <div className="field-set">
                <label>Line Item</label>
                <Controller
                name="adName" // Name of the form field
                control={form1.control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="adName_"
                    placeholder={
                     "Select LineItem"
                    }
                   
                    options={lineItemData}
                    className="!w-80"
                    classNamePrefix="select"
                  />
                )}
              />
                {form1.formState.errors.adName && (
                  <p className="text-red-600 my-0">LineItem is Required</p>
                )}
              </div>
              <div className="field-set align-vcenter ml-10">
                <label for="rotn">
                  <input
                    defaultChecked={props.rotation === 1 ? true : false}
                    {...form1.register("rotation", { required: false })}
                    type="checkbox"
                    id="rotn"
                  />{" "}
                  Rotation
                </label>
              </div>
              <div className="field-set align-vcenter-row">
                <button className="btn-submit" type="submit">
                  <span>Submit</span>{" "}
                  <img src="images/angle_right.svg" alt="" />
                </button>
                <button
                  className="btn-cancel"
                  onClick={() => {
                    setAdd(false);
                    setSubmitClicked(false);
                    setFormData(false);
                    setFormSubmit(false);
                    form1.reset();
                  }}
                >
                  <span>Cancel</span>
                </button>
              </div>
            </form>
          </div>
        ) : null}
        <div className={"existing-list"}>
          {!loader
            ? internalAds?.map((item, index) => {
                return (
                  <>
                    <div key={index} className={"exist-card"}>
                      <div className="head-row">
                        <label className="local-internal"> {item.type}</label>
                        <label className="cpd-internal">{item.campaign_type}</label>
                        <label className="status">
                          {item.status === 2
                            ? "Running"
                            : `Scheduled for ${formatDateWithTime(
                                item.start_date
                              )}`}{" "}
                        </label>
                      </div>
                      <p>
                        {" "}
                        {item.campaign_name}
                        <span>
                          <button onClick={() => {
                              setRemoveData({
                                position: props.position,
                                backfill: props.from === "Backfill",
                                campaign_id: item.campaign_id,
                                campaign_name: item.campaign_name,
                                ad_type: "panel",
                                action: 0,
                                backfill: props.backfill || props.from === "Backfill",
                                status: item.status,
                                rotation: item.rotation,
                              });
                              setHidden(item.hidden);
                              setNewPosition("");
                              setNewSlot(props.slot ?? 0);
                              setShowRemoveAlert(true);
                            }} disabled={props.from === "Backfill"} className="cursor-not-allowed">
                            <img
                            src={DeleteSvg}
                            alt="Delete"
                          />
                          </button>
                        </span>
                      </p>
                      <TargetPreview data={item} />
                      {item.hidden === 1 ? (
                        <span className="px-2 py-1 text-white absolute rounded-br-md  rounded-tl-md top-0 left-0 text-xs bg-green-700">
                          Hidden
                        </span>
                      ) : null}
                    </div>
                  </>
                );
              })
            : null}
        </div>
        <div>
          <Modal
            show={showRemoveAlert}
            onHide={() => {
              setShowRemoveAlert(false);
              setRemoveData({});
              setNewPosition("");
              setNewSlot(props.slot ?? 0);
            }}
            backdrop="static"
            animation={false}
            dialogClassName="modal-30w"
            centered
          >
            <ModalHeader closeButton>
              <ModalTitle>
                <h3>Are you Sure ?(Remove Ad)</h3>
              </ModalTitle>
            </ModalHeader>
            <ModalBody>
              <div>
                {/* <h3>Are you sure ?</h3> */}
                {removeData.campaign_name ? (
                  <div>
                    <h6 className="capitalize">
                      LineItem: {removeData.campaign_name}
                    </h6>
                    <h6>Position: {removeData.position}</h6>
                  </div>
                ) : (
                  <div>
                    <h6 className="capitalize">
                      Ad Name: {`${removeData.ad_unit}`}
                    </h6>
                    <h6>Position: {removeData.position}</h6>
                  </div>
                )}
                {/* <JsonView
                data={removeData}
                shouldExpandNode={allExpanded}
              ></JsonView> */}
                {removeData.status !== undefined && removeData.status !== 2 ? (
                  <div className="mt-3">
                    <div className="d-flex gap-2">
                      <div className="flex-grow-1">
                        <label className="form-label mb-1">
                          New Position <span className="text-red-600">*</span>
                        </label>
                        <input
                          type="number"
                          min="0"
                          className="form-control form-control-sm"
                          placeholder="Enter new position"
                          value={newPosition}
                          onChange={(e) => setNewPosition(e.target.value)}
                        />
                      </div>
                      <div style={{ width: "110px" }}>
                        <label className="form-label mb-1">
                          New Slot <span className="text-red-600">*</span>
                        </label>
                        <select
                          className="form-control form-control-sm"
                          value={newSlot}
                          onChange={(e) => setNewSlot(e.target.value)}
                        >
                          {slotOptions.map((slot, idx) => (
                            <option key={idx} value={idx}>
                              {slot}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <small className="text-muted">
                      This scheduled campaign will be published at the new
                      position &amp; slot before it is removed from position #
                      {removeData.position} {slotOptions[props.slot]}.
                    </small>
                  </div>
                ) : null}
                <div className="d-flex gap-3 justify-content-end mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    type="button"
                    onClick={() => {
                      setShowRemoveAlert(false);
                      setRemoveData({});
                      setNewPosition("");
                      setNewSlot(props.slot ?? 0);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    type="submit"
                    onClick={() => {
                      setRemoveClicked(true);
                      if (
                        removeData.status !== undefined &&
                        removeData.status !== 2
                      ) {
                        publishNewPositionAndRemove(removeData);
                      } else {
                        removeFromPosition(removeData);
                      }
                    }}
                    disabled={removeClicked}
                  >
                    {removeClicked && (
                      <span
                        className="spinner-grow spinner-grow-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                    {removeClicked
                      ? removeData.status !== undefined &&
                        removeData.status !== 2
                        ? "Moving..."
                        : "Removing..."
                      : removeData.status !== undefined &&
                        removeData.status !== 2
                      ? "Move & Remove"
                      : "Remove"}
                  </button>
                </div>
              </div>
            </ModalBody>
          </Modal>
        </div>
        <div>
        <Modal
  show={submitClicked}
  onHide={() => {
    setSubmitClicked(false);
    setAdd(false);
    setFormData(false);
    setFormSubmit(false);
    props.fetchAds(0, props.target_filter);
    setPreviewCampaignId(null);
  }}
  backdrop="static"
  animation={false}
  dialogClassName="modal-fullwidth"
  size="xl"
  centered
>
  <ModalHeader closeButton className="border-bottom bg-light">
    <div className="d-flex align-items-center justify-content-between w-100">
      <ModalTitle className="d-flex align-items-center mb-0">
        <i className="fas fa-list-alt me-2 text-primary"></i>
        <h4 className="mb-0 text-dark fw-bold">Existing Lineitems Overview</h4>
      </ModalTitle>

      {/* Actions */}
      <div className="d-flex gap-2 ms-3">
        <button
          className="btn btn-outline-danger btn-sm px-3 d-flex align-items-center"
          type="button"
          onClick={() => {
            setSubmitClicked(false);
            setAdd(false);
            setFormData(false);
            setFormSubmit(false);
            props.fetchAds(0, props.target_filter);
            setPreviewCampaignId(null);
          }}
        >
          <i className="fas fa-times me-1"></i>
          Cancel
        </button>

        <button
          className="btn btn-primary btn-sm px-3 d-flex align-items-center position-relative"
          type="submit"
          onClick={() => {
            setFormSubmit(true);
            onSubmit(formData);
          }}
          disabled={formSubmit}
          style={{ minWidth: "120px" }}
        >
          {formSubmit && (
            <span
              className="spinner-border spinner-border-sm me-1"
              role="status"
              aria-hidden="true"
              style={{ width: "0.8rem", height: "0.8rem" }}
            ></span>
          )}
          <i className={`fas ${formSubmit ? "fa-spinner fa-spin" : "fa-check"} me-1`}></i>
          {formSubmit && submitProgress.total > 1
            ? `${submitProgress.completed}/${submitProgress.total} done...`
            : formSubmit ? "Submitting..." : "Submit"}
        </button>
      </div>
    </div>
  </ModalHeader>

  <ModalBody className="p-4" style={{ maxHeight: "80vh", overflowY: "auto" }}>
    {submitProgress.total > 1 && (
      <div className="mb-3 px-1">
        <div className="d-flex justify-content-between small mb-1">
          <span className="text-muted">
            {submitProgress.completed < submitProgress.total
              ? <>Adding to position <b>#{submitProgress.currentPos}</b>…</>
              : <span className="text-success fw-semibold">Done! Added to {submitProgress.total} positions</span>}
          </span>
          <span className="text-muted">{submitProgress.completed}/{submitProgress.total}</span>
        </div>
        <div className="progress" style={{ height: '6px' }}>
          <div
            className="progress-bar bg-success"
            style={{ width: `${(submitProgress.completed / submitProgress.total) * 100}%`, transition: 'width 0.3s ease' }}
          />
        </div>
      </div>
    )}
    <div className="container-fluid">
      <div className="row">

        {/* Combined Lineitems & Alerts */}
        <div className="col-12 mb-4">
          <div className="card border-0 shadow-sm">
            <div
              className="card-header bg-gradient text-white d-flex align-items-center"
              style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              }}
            >
              <i className="fas fa-tags me-2"></i>
              <h5 className="mb-0 fw-semibold">Lineitems & Matching Alerts</h5>
              <span className="badge bg-light text-dark ms-auto">
                {
                  (matchAdCodeAlert?.dfp_lineitems_alerts?.length || 0) +
                  (matchAdCodeAlert?.networkAd_alerts?.length || 0) +
                  (matchAdCodeAlert?.overlappingLineitems?.length || 0)}{" "}
                items
              </span>
            </div>

            <div className="card-body p-3">

              <div className="row g-2">

                {/* === DFP Alerts (Yellow) === */}
                {matchAdCodeAlert?.dfp_lineitems_alerts?.map((item, index) => (
                  <div key={`dfp-${index}`} className="col-md-6 col-lg-4 d-flex">
                    <div
                      className="alert w-100 h-100 mb-2 border-0 shadow-sm d-flex align-items-center p-1"
                      style={{
                        backgroundColor: "#ede7f6",  // light violet
                        color: "#4a148c",  
                        fontWeight: 500,
                      }}
                    >
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      <span>
                        {item.campaign_name} ({item.ad_code}) — P{item.position} {slotOptions[item.slot]}
                      </span>
                      <span
                        className="badge ms-auto"
                        style={{ backgroundColor: "#d1c4e9", color: "#4a148c" }}
                      >
                        DFP Match
                      </span>
                    </div>
                  </div>
                ))}

                {/* === Network Ads Alerts (Red) === */}
                {matchAdCodeAlert?.networkAd_alerts?.map((item, index) => (
                  <div key={`net-${index}`} className="col-md-6 col-lg-4 d-flex">
                    <div
                      className="alert w-100 h-100 mb-2 border-0 shadow-sm d-flex align-items-center p-1"
                      style={{
                        backgroundColor: "#fff3cd",
                        color: "#856404",
                        fontWeight: 500,
                      }}
                    >
                      <i className="fas fa-exclamation-circle me-2"></i>
                      <span>
                        {item.ad_name} ({item.ad_code})
                        {item.position ? ` — P${item.position}` : ""}
                      </span>
                      <span
                        className="badge ms-auto"
                        style={{ backgroundColor: "#ffeeba", color: "#856404" }}
                      >
                        Network Match
                      </span>
                    </div>
                  </div>
                ))}

                {/* === Overlapping Audience Target Lineitems (Teal) === */}
                {matchAdCodeAlert?.overlappingLineitems?.map((item, index) => {
                  const st = getOverlapStatus(item.status);
                  return (
                    <div key={`ov-${index}`} className="col-md-6 col-lg-4 d-flex">
                      <div
                        className="alert w-100 h-100 mb-2 border-0 shadow-sm d-flex align-items-center p-1"
                        style={{
                          backgroundColor: "#e0f2f1",
                          color: "#004d40",
                          fontWeight: 500,
                        }}
                      >
                        <i className="fas fa-users me-2"></i>
                        <span>{item.campaign_name}</span>
                        <span
                          className="badge ms-auto"
                          style={{ backgroundColor: st.bg, color: st.color, fontSize: st.fontSize }}
                        >
                          {st.label}
                        </span>
                      </div>
                    </div>
                  );
                })}

                {/* === NO DATA === */}
                {
                  (matchAdCodeAlert?.dfp_lineitems_alerts?.length || 0) === 0 &&
                  (matchAdCodeAlert?.networkAd_alerts?.length || 0) === 0 &&
                  (matchAdCodeAlert?.overlappingLineitems?.length || 0) === 0 && (
                    <div className="text-center py-4">
                      <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
                      <h5 className="text-muted">No Lineitems Found</h5>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>

        {/* Preview Section */}
        {previewCampaignId && (
          <div className="col-12 mb-4">
            <div className="card border-0 shadow-sm">
              <div
                className="card-header bg-gradient text-white d-flex align-items-center"
                style={{
                  background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                }}
              >
                <i className="fas fa-eye me-2"></i>
                <h5 className="mb-0 fw-semibold">Lineitem Preview</h5>
                <small className="ms-auto opacity-75">
                  Campaign ID: {previewCampaignId}
                </small>
              </div>
              <div className="card-body p-3">
                <LineitemPreview campaign_id={previewCampaignId} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  </ModalBody>
</Modal>

        </div>
      </div>
    </div>
    </Modal>
  );
}
export default InternalAds;
